import { Modal } from '@mui/material';
import { styled } from "@mui/material/styles";
import All from "./OnBoardingBody";

const MainModal = styled(Modal)(({ theme }) => ({
  height: '95vh',
  maxWidth: '500px',
  margin: 'auto',
  overflowY: 'auto',
  borderRadius: '50px',
  boxShadow: theme.shadows[10]
}));

const OnBoarding = (props : any) => {
  return (
  <MainModal open={true} className="scrollbar-hidden">
    <All/>
  </MainModal>
  );
};

export default OnBoarding;